import React, {useCallback, useEffect} from 'react';
import Modal from '~/app/common/Modal';
import classes from './style.module.scss';
import Icon from '~/app/common/Icon';

export interface ExternalLinkProps {
    onClose: (boolean) => void
    open: boolean
    url: string
}

export type ExternalLinkComponent = React.FC<ExternalLinkProps>

function hasInAppBrowser(): boolean {
    return typeof window !== 'undefined' && !!window['cordova']?.InAppBrowser;
}

const ExternalLink: ExternalLinkComponent = ({onClose, open, url}) => {
    const cancelClickHandler = useCallback((): void => {
        onClose(false);
    }, [onClose]);

    useEffect(() => {
        if (!hasInAppBrowser() || !open || !url) {
            return;
        }
        const cordova = window['cordova'];
        const isIos = cordova.platformId === 'ios';

        if (isIos) {
            // _blank is unreliable on iOS WKWebView with cordova-plugin-inappbrowser 6.x; Safari via _system is stable.
            cordova.InAppBrowser.open(url, '_system');
            cancelClickHandler();
            return;
        }

        const ref = cordova.InAppBrowser.open(url, '_blank', 'location=no');
        ref.addEventListener('exit', cancelClickHandler);
        return () => ref.removeEventListener('exit', cancelClickHandler);
    }, [open, url, cancelClickHandler]);

    if (hasInAppBrowser()) {
        return <></>;
    }

    return (
        <Modal open={open} position={'top'} className={classes['content']}>
            <Icon name={'close'} className={classes['abort']} onClick={cancelClickHandler}/>
            <iframe title="content-window" src={url} className={classes['content-window']}></iframe>
        </Modal>
    );
};

export default ExternalLink
